import React, { useEffect, useMemo } from "react";
import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { fileTypeIcon, isImageContentType } from "./chatFilePreview";
import classes from "./ChatTray.module.css";

function PendingFileChip({ file, previewUrl, onRemove }) {
  const isImage = isImageContentType(file.type);

  return (
    <div className={classes.pendingChip}>
      {isImage && previewUrl ? (
        <img
          className={classes.pendingThumb}
          src={previewUrl}
          alt={file.name}
        />
      ) : (
        <span className={classes.pendingIcon}>{fileTypeIcon(file.type, 16)}</span>
      )}
      <Text size="xs" className={classes.pendingName} lineClamp={1}>
        {file.name}
      </Text>
      <ActionIcon
        size="xs"
        variant="subtle"
        color="gray"
        aria-label={`Remove ${file.name}`}
        onClick={onRemove}
      >
        <IconX size={12} />
      </ActionIcon>
    </div>
  );
}

export default function ChatPendingFiles({ files, onRemove, onClearAll }) {
  const previewUrls = useMemo(() => {
    return (files || []).map((file) =>
      isImageContentType(file.type) ? URL.createObjectURL(file) : null
    );
  }, [files]);

  useEffect(() => {
    return () => {
      previewUrls.forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [previewUrls]);

  if (!files?.length) return null;

  function removeFile(index) {
    const next = files.filter((_, rowIndex) => rowIndex !== index);
    if (next.length === 0) {
      onClearAll?.();
      return;
    }
    onRemove(next);
  }

  return (
    <Group gap={8} mb={6} wrap="wrap">
      {files.map((file, index) => (
        <PendingFileChip
          key={`${file.name}-${file.lastModified}-${index}`}
          file={file}
          previewUrl={previewUrls[index]}
          onRemove={() => removeFile(index)}
        />
      ))}
    </Group>
  );
}
